import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import PageNotFound from "./components/PageNotFound";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppLayout from "./components/Layout/AppLayout"; // <-- import AppLayout
import PasswordReset from "./components/PasswordReset";
import axios from "axios";
import CryptoJS from "crypto-js";
import { API_URL, secret_key } from "./components/Constants";
import loading1 from "./assets/loading.gif";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const encryptedToken = localStorage.getItem('token');
    let decryptedToken = '';
    if (encryptedToken) {
      try {
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
        decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.log('Error.');
      }
    }

    const token = decryptedToken;

    if (token) {
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_URL}/verify`,
        headers: { 'Authorization': `Bearer ${token}` }
      };

      axios.request(config)
        .then((response) => {
          setIsAuthenticated(response.data.message === 1);
        })
        .catch(() => setIsAuthenticated(false))
        .finally(() => setLoading(false));
    } else {
      setIsAuthenticated(false);
      setLoading(false);
    }
  }, []);

  return (
    <BrowserRouter>
      {loading ? (
        <div className="loadingcontainer">
          <img className="loadingimg" src={loading1} alt="" />
        </div>
      ) : (
        <Routes>
          {/* All routes that require authentication use AppLayout */}
          <Route
            path="/*"
            element={
              isAuthenticated ? <AppLayout /> : <Navigate to="/login" replace />
            }
          />

          {/* Public routes */}
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
          />
          <Route path="/register" element={<Register />} />
          <Route path="/password_reset" element={<PasswordReset />} />
          <Route
            path="*"
            element={
              isAuthenticated ? <PageNotFound /> : <Navigate to="/login" replace />
            }
          />
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;
